import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 800px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
    background-color: var(--green);

    &:hover,
    &:focus {
      outline: 0;

      &:after {
        top: 15px;
        left: 15px;
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: var(--border-radius);
      // mix-blend-mode: multiply;
      // filter: grayscale(100%) contrast(1);
      transition: var(--transition);
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before {
      top: 0;
      left: 0;
      background-color: var(--navy);
      mix-blend-mode: screen;
    }

    &:after {
      border: 2px solid var(--green);
      top: 20px;
      left: 20px;
      z-index: -1;
    }
  }
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, [prefersReducedMotion]);

  // const skills = [
  //   'JS/TS',
  //   'Common Lisp',
  //   'Java',
  //   'C/C++',
  //   'Python (Pytorch, Tensorflow)',
  //   'MERN, LAMP stack',
  // ];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">Hey there!</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
              I'm Felix, a CS PhD student at{' '}
              <a href="https://www.tsinghua.edu.cn/en/">Tsinghua University</a>. I'm researching{' '}
              <a href="https://felixgan.substack.com/">DNN control and steering</a> and building an{' '}
              <a href="https://felixgan.substack.com/">early-stage robotics startup</a>. Previously,
              I obtained my B.S. at <a href="https://www.ucla.edu/">UCLA</a> and M.S. at{' '}
              <a href="https://www.jhu.edu/">Johns Hopkins</a>.
            </p>

            <p>
              In the past, I had the pleasure of working at{' '}
              <a href="https://www.amazon.com/">a large tech</a>,{' '}
              {/* <a href="https://www.ksldx.com/">a biomedical laboratory</a>, */}
              <a href="https://nucleate.xyz/">a biotech venture</a>,{' '}
              {/* <a href="http://www.witlink.link/">my smart furniture startup</a>, */}
              {/* <a href="https://uclastudentmedia.com/">a university newsletter</a>, */}
              and <a href="https://www.fps-productions.com/">a student-led film production</a>.
            </p>

            {/* <p>
              At the moment, I'm working on an{' '}
              <a href="https://getfortuna.wixsite.com/fortuna">early stage fintech startup idea</a>{' '}
              as well as expanding my <a href="http://www.witlink.link/">smart furniture startup</a>.
            </p> */}

            {/* <p>Here are a few technologies I’ve worked with in the past:</p> */}

            <p>
              Apart from work, I enjoy{' '}
              <a href="https://www.uclabilliards.com/">playing billiards</a>,{' '}
              <a href="https://www.ted.com/tedx/events/65147">curating events</a>, and{' '}
              <a href="https://gca-global.org/">fostering communities</a> of amazing people.
            </p>
          </div>

          {/* <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul> */}
        </StyledText>

        <StyledPic>
          <div className="wrapper">
            <StaticImage
              className="img"
              src="../../images/me-2.jpg"
              width={500}
              quality={100}
              formats={['AUTO', 'WEBP', 'AVIF']}
              alt="Headshot"
            />
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
};

export default About;
